import React, { useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Chip,
  TextField,
  IconButton,
  CircularProgress
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Clear";
import EventBus from "../../utils/EventBus";
import EventNames from "../../utils/EventNames";

function MetadataEditor({ section, labelOverride, label, keyName, values = [], onUpdate, validateDelete, onClickChip }) {
  const [newValue, setNewValue] = useState("");
  const [validatingItem, setValidatingItem] = useState('')

  const handleAdd = () => {
    const trimmed = newValue.trim();
    if (trimmed && !values.includes(trimmed)) {
      onUpdate([...values, trimmed], trimmed, false);
      setNewValue("");
    }
  };

  const handleDelete = async (index) => {
    const toDelete = values[index]
    setValidatingItem(toDelete)
    const inUse = await validateDelete(toDelete)
    const canDelete = !inUse
    if(canDelete) {
      const updated = values.filter((_, i) => i !== index);
      onUpdate(updated, toDelete, true);
    } else {
      EventBus.emit(EventNames.ALERT, {
        text: <span>{`Can't remove ${toDelete} since it is in use.`}</span>,
        style: 'error',
        duration: 3000,
        showClose: true
      })
    }
    setValidatingItem('')
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">
        {labelOverride && labelOverride}{!labelOverride && keyName.charAt(0).toUpperCase() + keyName.slice(1)}
      </Typography>
      <Divider sx={{ mb: 1 }} />

      {/* Chips list */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {values
        .sort((a,b) => a.localeCompare(b))
        .map((val, index) => {
          const isLoading = val === validatingItem;

          return (
            <Chip
              key={`${val}-${index}`}
              size="small"
              sx={{
                "& .MuiChip-label": {
                  px: 1.5
                }
              }}
              label={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {isLoading ? <CircularProgress size={16} /> : val}
                </Box>
              }
              // CLICK HANDLER
              onClick={() => {
                if (onClickChip) onClickChip(val);
              }}
              // DELETE HANDLER
              onDelete={
                !isLoading ? () => handleDelete(index) : undefined
              }
              deleteIcon={<DeleteIcon />}
              color="default"
              variant="outlined"
              clickable
            />
          );
        })}
      </Box>
      {/* Add new chip */}
      <Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 1 }}>
        <TextField
          label={`Add ${label}`}
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          size="small"
        />
        <IconButton color="primary" onClick={handleAdd}>
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

export default MetadataEditor;